import Vue from "vue";
import YiComp from "@ydc/yi-ui";
import "@ydc/iconfont/font";
import "@ydc/yi-ui/lib/theme/default/default.min.css";

Vue.use(YiComp);
